import { ICellRendererParams } from "ag-grid-community";

export const ChipCellRenderer = (params: ICellRendererParams) => {
	if (!params.value) {
		return null;
	}

	return <span className="custom-chip">{params.value}</span>;
};
